import { render } from "./branch-copy-position.vue?vue&type=template&id=13e23d32"
import script from "./branch-copy-position.vue?vue&type=script&lang=js"
export * from "./branch-copy-position.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__